import { IconNames } from '~/enums'

export default defineAppConfig({
  ui: {
    colors: {
      primary: 'atlantis',
      neutral: 'slate',
    },
    icons: {
      dark: IconNames.moon_star,
      light: IconNames.sun,
      system: IconNames.monitor_01,
      search: IconNames.search_md,
      external: IconNames.arrow_up_right,
      chevron: IconNames.chevron_down,
      hash: IconNames.hash_02,
      menu: IconNames.menu_03,
      close: IconNames.x_close,
    },
    safelistColors: ['error', 'success', 'info', 'warning', 'neutral'],
    notifications: {
      // Show toasts at the top right of the screen
      position: 'top-0 inset-x-0 mx-auto bottom-auto',
      width: 'md:w-full md:max-w-md xl:max-w-lg',
    },
    button: {
      variants: {
        variant: {
          link: 'p-0',
        },
      },
      compoundVariants: [
        {
          variant: 'link',
          class: 'p-0',
        },
      ],
    },
    card: {
      slots: {
        body: 'py-3 sm:py-4 sm:px-4',
        header: 'py-3 sm:py-4 sm:px-4',
        root: 'relative',
        title: 'text-base text-neutral-700 dark:text-neutral-200 font-medium',
      },
    },
    skeleton: {
      slots: {
        base: 'ring-1 ring-accented bg-elevated',
      },
    },
    avatar: {
      slots: {
        root: 'rounded-sm',
      },
    },
    slideover: {
      slots: {
        content: 'max-w-xl',
        overlay: 'bg-neutral-800/70 dark:bg-neutral-800/90',
      },
    },
    formField: {
      slots: {
        label: 'mb-1',
      },
    },
    alert: {
      compoundVariants: [
        {
          color: 'neutral',
          variant: 'solid',
          class: {
            root: 'text-inverted bg-inverted hover:bg-neutral-800 disabled:bg-neutral-900 dark:hover:bg-neutral-100 dark:disabled:bg-default focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400',
          },
        },
      ],
    },
    page: {
      slots: {
        header: {
          title: 'font-medium text-2xl sm:text-3xl',
          description: 'mt-1',
          wrapper: 'pb-4 pt-8',
          container: 'flex-row',
        },
      },
    },
    modal: {
      slots: {
        content: 'rounded-lg',
        header: 'border-b-2 border-neutral-200 dark:border-neutral-700 p-4',
        title: 'text-base font-medium',
        description: 'text-sm',
        icon: 'size-6 text-toned',
        footer: 'justify-end',
      },
    },

    dashboard: {
      sidebar: {
        slots: {
          links: {
            wrapper: 'space-y-2',
          },
        },
      },

      slideover: {
        slots: {
          title: 'text-lg lg:text-xl',
        },
      },
    },
    input: {
      slots: {
        root: 'flex',
      },
      defaultVariants: {
        size: 'md',
      },
    },
    dropdown: {
      slots: {
        content: 'w-auto',
      },
    },
    textarea: {
      defaultVariants: {
        size: 'md',
      },
    },
    select: {
      defaultVariants: {
        size: 'md',
      },
    },
    selectMenu: {
      defaultVariants: {
        size: 'md',
      },
    },
    inputMenu: {
      defaultVariants: {
        size: 'md',
      },
    },
    radio: {
      slots: {
        label: 'font-normal',
      },
    },
    radioGroup: {
      slots: {
        legend: 'mb-1.5',
        fieldset: '!gap-y-3',
        label: 'font-normal',
      },
    },
    tooltip: {
      slots: {
        content: 'max-w-full',
      },
    },
    table: {
      slots: {
        td: 'py-2 max-w-60 truncate',
        th: 'max-w-60 truncate text-sm text-default font-medium',
      },
      variants: {
        pinned: {
          true: {
            td: 'bg-default',
            th: 'bg-default',
          },
        },
      },
    },
  },
})
